<template>
<div>
	<base-header v-once pageName="조직관리 상세" :popup="true"></base-header>
	<section id="wrap">
		<div class="ep-info">			
			<a v-bind:href="'tel:'+userInfo.hpno"><button type="button" class="icon tel">전화</button></a>
			<a v-bind:href="'sms:'+userInfo.hpno"><button type="button" class="icon email">문자</button></a>
			<div class="user">
				<figure>
					<img v-if="!setNoImg && userInfo.rpimgp != null && userInfo.rpimgp != 'null'" 
						v-bind:src="userInfo.kssImgUrl + userInfo.rpimgp" 
						@error="imgDefaultSet"  alt="">
					<img v-else src="@/assets/images/avatar200.png">
				</figure>
				<p><em :class="userInfo.gubun | jicClass"></em> <span>{{userInfo.akdnam}} <i>({{userInfo.akdcde}})</i></span></p>
				<span>{{userInfo.gnrlName}}/{{userInfo.cntrName}}</span>
				<span>{{userInfo.akdid1 | birthDate}}</span>
			</div>
			<p v-if="graphShow && masterShow">
				<span>다음 <b>{{userInfo.need | numFormat}}</b>원 달성 시 <b>위촉 ({{nextTit}}) '매출 기준'</b> 달성입니다.</span>
			</p>
			<p v-if="graphShow && !masterShow">
				<span>다음 <b>{{userInfo.need | numFormat}}</b>원 달성 시 <b>{{nextTit}}</b> 매출 기준 달성입니다.</span>
			</p>
			<div class="graph" v-if="graphShow && !masterShow">
				<p :class="state"><em></em></p>
				<span>누적 {{ userInfo.siljuck | numFormat}}원</span>
				<i>플래너</i>
				<i>{{nextTit}}</i>
			</div>
			<div class="graph" v-if="graphShow && masterShow">
				<p :class="state"><em></em></p>
				<span>누적 {{ userInfo.siljuck | numFormat}}원</span>
				<i>마스터</i>
				<i>{{nextTit}}</i>
			</div>
			<button type="button" class="profile" @click="showProfile">프로필 상세</button>
		</div>

		<div class="detail-month">
			<div class="detail-result">
				<h6>{{month}}월 실적 상세</h6>
				<div>
					<div class="month">
						<b>당월 인정 실적</b>
						<em>{{performInfo.perform > 3000000 ?	"실활동" : (performInfo.perform > 0 ? "가동" : "미가동")}}</em>
						<span><i>{{ performInfo.perform | numFormat}}</i> 원</span>
					</div>
					<div class="item">
						<strong>예상 수수료 조회하기</strong>
						<button type="button" class="more" @click="goOtherSite('kss','/hdof/cmmsExpcInq')">자세히보기</button>
						<!-- 2022-09-22 : 예상 수수료값 노출 안함, kss에서 확인
						<ul>
							<li>㈜교원에듀 : {{ performInfo.totCmms | numFormat}}원</li>
						</ul> -->
					</div>
				</div>
			</div>
			<div class="detail-activity">
				<h6>{{month}}월 활동 상세</h6>
				<div>
					<ul>
						<li>아침 미팅</li>
						<li>{{activityInfo.meetCnt}}일</li>
						<li>소스등록</li>
						<li>{{activityInfo.custmCnt}}건</li>
						<li>북케어</li>
						<li>{{activityInfo.bkcareCnt}}건</li>
						<li>화상접수</li>
						<li>{{activityInfo.vdClssCnt}}건</li>
						<!-- <li>리크루팅</li>
						<li>{{activityInfo.recruitCnt}}건</li> -->
					</ul>
					<div>
						<strong>상담</strong>
						<span><b>{{activityInfo.cnslCnt}}</b>건</span>
						<dl>
							<dt>상품</dt>
							<dd>{{activityInfo.planCnt}}건</dd>
							<dt>리크루팅</dt>
							<dd>{{activityInfo.schRcrtCnt}}건</dd>
							<dt>진단검사</dt>
							<dd>{{activityInfo.schTestCnt}}건</dd>
						</dl>
					</div>
					<div>
						<strong>진단검사</strong>
						<span><b>{{activityInfo.dgnstCnt}}</b>건</span>
						<dl>
							<dt>KED-I</dt>
							<dd>{{activityInfo.kedICnt}}건</dd>
							<dt>KED-S</dt>
							<dd>{{activityInfo.kedSCnt}}건</dd>
							<dt>AI ELT</dt>
							<dd>{{activityInfo.aiEltCnt}}건</dd>
						</dl>
					</div>
				</div>
			</div>
		</div>

		<div class="my-studyInfo">
			<div>
				<h4>필수 교육과정</h4>
				<ul>
					<li class="head">
						<strong>교육과정</strong>
						<strong>수료</strong>
					</li>
					<li v-for="(item,index) in eduInfo" :key="index">
						<span>{{item.lecNm}}</span>
						<i class="yes"></i>
					</li>
				</ul>
			</div>
			<div>
				<h4>진행중인 Studit 교육과정</h4>
				<div class="curriculum" v-if="studitList.length > 0">
					<button type="button" 
					v-for="item in studitList"
					:key="item.reqSeq">
						<figure><img :src="thumbnailUrl+item.uuid" alt=""></figure>
						<span :class="item.cateNm | cateClass">{{item.cateNm}}</span>
						<strong>{{item.lecNm}}</strong>
					</button>
				</div>
				<div class="dataNone" v-if="studitList.length < 1">
					현재 진행중인 교육이 없습니다.
				</div>
			</div>
		</div>

		<div class="memo-list">
			<p>
				<strong>메모장</strong>
				<span>※ 등록한 메모는 나에게만 보여집니다.</span>
				<button type="button" @click="showMemo()">메모하기</button>
			</p>
			<ul>
				<li v-for="(item, index) in memoList" :key="item.sqno">
					<span>{{item.cntn}}</span>
					<em>{{item.crtnDttm}}</em>
					<button type="button" class="view" @click="showMemo(index)">보기</button>
					<button type="button" class="del" @click="deleteMemo(index)">삭제</button>
				</li>
			</ul>
		</div>
	</section>
</div>
</template>

<script>
export default {
	name: "OrgnzDetail",
	components: {
	},
	data() {
		return{
			month: new Date().getMonth()+1,
			graphShow:false,
			masterShow:false,
			nextTit:'',
			state:'Lv1',
			userInfo:{
				akdcde : this.$route.query.targetId,
				gubun : this.$route.query.gubun,
				akdnam : this.$route.query.akdnam
			},
			performInfo:{},
			activityInfo:{},
			eduInfo:[],
			studitList:[],
			memoList:[],
			thumbnailUrl:'http://cubig.kyowon.co.kr/upload/data2/doclink/',
			setNoImg: false,
		};
	},
	watch: {
		'$store.state.ui.child'(child) {
			if(child.name == 'orgnz-memo-refresh'){
				this.getMemoList();
			}
		}
	},
	methods: {
		showProfile:function(){
			var param = "?targetId="+this.$route.query.targetId;
			param += "&akdnam="+this.userInfo.akdnam;
			param += "&gubun="+this.userInfo.gubun;
			this.$utils.nativeIf.outbound.newPage("/orgStatus/orgStatusView/profileDetails"+param);
		},
		goOtherSite:function(type, url){
			var msg = ''
			if(type == 'kss'){
				var that = this;
				this.$api.dashboard
				.getSsoToken()
				.then(function (data) {
					// console.log("GET TOKEN.",data)
					msg = "OK ";
					if(data && data.token && data.userIdEnc){
						var ssoUrl = 'http://ksos.kyowon.co.kr?';
						ssoUrl += 'userId='+data.userIdEnc+'&token='+data.token;
						if(url){
							ssoUrl += '&path='+encodeURIComponent(url);
						}
						
						msg += " "+ssoUrl;
						that.$utils.nativeIf.outbound.outlink(ssoUrl)
					}else{
						// alert("SSO연동에 실패 하였습니다.")
						that.$utils.nativeIf.outbound.outlink("https://ksos.kyowon.co.kr"+url);
					}
				})
				.catch(function (error) {
					alert(error+"\n\n"+msg);
				});
			}
		},
		showMemo:function(index){
			var memoData = {
				targetId : this.userInfo.akdcde,
				gubun : this.userInfo.gubun,
				name : this.userInfo.akdnam
			}
			if(index > -1){
				memoData.sqno = this.memoList[index].sqno,
				memoData.contents = this.memoList[index].cntn
			}
			var parent = {
				name: 'orgnz-target-memo',
				data: memoData
			};
			this.$store.commit("SET_UI_PARENT", parent);
			this.$utils.nativeIf.outbound.newPage("/orgStatus/orgStatusView/memo");

		},
		deleteMemo:function(index){
			if(confirm("메모를 삭제하시겠습니까?")){
				var that = this
				var parameters = {
					'sqno':this.memoList[index].sqno
				};
				this.$api.orgnz
				.memoDelete(parameters)
				.then(function(data) {
					if(data && data > 0){
						alert("삭제되었습니다.");
						that.memoList.splice(index,1);
					}else{
						alert("삭제에 실패하였습니다.");
					}
				})
				.catch(function(error) {
						alert(error.rtMsg);
				});
			}
		},
		getMemoList:function(){
			var that = this
			var parameters = {
				'targetId': this.$route.query.targetId
			};
			this.$api.orgnz
			.memoList(parameters)
			.then(function(data) {

				if(data)
					that.memoList = data;

			})
			.catch(function(error) {
					alert(error.rtMsg);
			});
		},
		imgDefaultSet(){
			this.setNoImg = true;
		}
	},
	created: function() {
		// 차세대에서는 그래프를 노출 함.
		// var paramGubun = this.$route.query.gubun;
		// if(paramGubun != "COG06"){	 //E-PA 일때 그래프 노출 안함.
		// 	this.graphShow = true;
		// }
		// if(paramGubun == "COGA2"){
		// 	this.masterShow = true;
		// }

		var that = this
		var parameters = {
			'targetId': this.$route.query.targetId
		};
		
		this.$api.orgnz
		.detail(parameters)
		.then(function(data) {
			var userInfo = data;
			var siljuck = userInfo.siljuck;
			if(siljuck == undefined) {
				siljuck = 0;
			}
	
			// if(userInfo.gubun != "COG06"){	 //E-PA 일때 그래프 노출 안함.
			// 	that.graphShow = true;
			// }

			if(userInfo.gubun == "COGA2"){
				that.masterShow = true;
				
				that.nextTit = "지국장";
				if(siljuck > 100000000){	 //지국장달성
					userInfo.need = 0
					that.state='Lv5';
				}else{
					userInfo.need = 100000000 - siljuck
					that.state='Lv3';
					if(siljuck < 1){
					that.state='Lv1';
					}
				}
			}else{
				if(siljuck > 50000000){	 //지국장달성
					userInfo.need = 0
					that.nextTit = "마스터";
					that.state='Lv5';
				}else if(siljuck > 25000000){ //프로달성
					userInfo.need = 50000000 - siljuck
					that.nextTit = "마스터";
					that.state='Lv4';
				}else if(siljuck > 0){ //일반
					userInfo.need = 50000000 - siljuck
					that.nextTit = "마스터";
					that.state='Lv2';
				}else{
					userInfo.need = 50000000;
					that.nextTit = "마스터";
					that.state='Lv1';
				}
			}
			that.userInfo = userInfo;

			parameters.gubun = userInfo.gubun;
			
			that.$api.orgnz
			.perform(parameters)
			.then(function(data) {
				if(data)
					that.performInfo = data;
			})
			.catch(function(error) {
				alert(error.rtMsg);
			});
		})
		.catch(function(error) {
			alert(error.rtMsg);
		});

		this.$api.orgnz
		.activity(parameters)
		.then(function(data) {
			if(data.activityInfo){
				var activityInfo = data.activityInfo;
				activityInfo.dgnstCnt = activityInfo.kedICnt + activityInfo.kedSCnt + activityInfo.aiEltCnt;
				activityInfo.cnslCnt = activityInfo.planCnt + activityInfo.schRcrtCnt + activityInfo.schTestCnt;
				that.activityInfo = activityInfo;
			}

			if(data.eduInfo)
				that.eduInfo = data.eduInfo;

			if(data.studitList)
				that.studitList = data.studitList;

			if(data.memoList)
				that.memoList = data.memoList;

		})
		.catch(function(error) {
			alert(error.rtMsg);
		});

		this.getMemoList();
	},
	filters:{
		numFormat:function(num){
			if(!num || num==0) return 0;

			var n = num+'';
			var reg = /(^[+-]?\d+)(\d{3})/;
			
			while (reg.test(n))
				n = n.replace(reg,'$1'+','+'$2');
			
			return n;
		},
		birthDate:function(date){
			if(!date) return date;

			var birthDay = date;
			if(date.length == 8){
				birthDay = date.substring(0,4) + ".";
				birthDay += date.substring(4,6) + ".";
				birthDay += date.substring(6,8);
			}else if(date.length == 6){
				if(date.substring(0,2) < 50){
					birthDay =20;
				}else{
					birthDay =19;
				}
				birthDay += date.substring(0,2) + ".";
				birthDay += date.substring(2,4) + ".";
				birthDay += date.substring(4,6);
			}
			
			return birthDay;
		},
		jicClass:function(gubun){
			if(gubun == 'COG01'){
				return "epLv";
			}else if(gubun == 'COG02'){ 
				return "epLv1";
			}else if(gubun == 'COGA2'){ 
				return "epLvA1";
			}else if(gubun == 'COG03'){ 
				return "epLv2";
			}else if(gubun == 'COG04'){
				return "epLv3";
			}else if(gubun == 'COG05'){
				return "epLv4";
			}else if(gubun == 'COG06'){
				return "epLv5";
			}
		},
		cateClass:function(cateNm){
			if(cateNm.indexOf('영업') > -1){
				return 'ord-time';
			}else if(cateNm.indexOf('전문') > -1){
				return 'regular';
			}else if(cateNm.indexOf('육성') > -1){
				return 'special';
			}else if(cateNm.indexOf('KSS') > -1){
				return 'kss';
			}
		}
	}
};
</script>
